<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()" >
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Beer</ion-title>
  </ion-toolbar>
</ion-header>
<ion-searchbar
  [(ngModel)]="searchQuery"
  *ngrxLet="allItems$ as allItems"
  (ionInput)="onSearch($event, allItems)">
</ion-searchbar>

@if (items != null) {
  <ion-content>
    <ion-card class="ion-no-padding">
      <ion-card-content class="ion-no-padding">
        <ion-list lines="full" class="ion-no-padding">
          @for (item of items; track item; let i = $index) {
            <ion-item
              (click)="selectItem(item)" button
              routerLinkActive="router-link-active">
              <ion-thumbnail slot="start">
                @if (item.image) {
                  <img [src]="item.image" />
                }
                @if (!item.image) {
                  <img src="/assets/icons/flat/beer/glass-mug-2.svg" />
                }
              </ion-thumbnail>
              <ion-label>{{item.name}}</ion-label>
            </ion-item>
          }
        </ion-list>
      </ion-card-content>
    </ion-card>
  </ion-content>
}
<span *ngrxLet="allItems$ as allItems"></span>
